import { ReactNode } from 'react';
import { message } from 'antd';
declare type NoticeType = 'success' | 'error' | 'info' | 'warning';
/**
 * MTools.Tips({ type, title })
 */

const Notify = (type: NoticeType, messages: string | ReactNode) => {
  if (!messages) return;
  message.open({
    type: type,
    content: messages
  });
};

export default Notify;
